import React, { Suspense, useEffect, useState } from 'react';
import FormGenerator from '../../../Cells/Form/FormGenerator';
import { Banner, Checkbox, Button, Linker } from '../../../Atoms';
//import { useSelector } from 'react-redux';
import SectionHeader from '../../../Molecules/SectionHeader';
import { useDispatch, useSelector } from 'react-redux';
import toast, { Toaster } from 'react-hot-toast';
import { callConstants } from '../../../../Store/Slices/Entities/constants/index';
import { constantsList } from '../../../../Common/Constants/index';
import { MercerButton } from '../../../Atoms';
import errorFile from '../../../../Assets/Images/iconError.png'
import $ from 'jquery';

import './styles.css';
import { SHOW_ALERT, LOCK_CONTINUE_BUTTON, CLOSE_ERROR, CLEAR_EMPLOYEE_VALIDATION_ERROR } from '../../../../Store/Slices/RegisterationError';
import iconError from '../../../../Assets/Images/iconError.png';
import registerImage from '../../../../Assets/Images/register-image.png';


const AddUserRegistration = (props) => {
  const { currentLanguage } = useSelector((storeState) => storeState.language);
  const { registerationError } = useSelector((storeState) => storeState);
  const {stepForm} = useSelector((storeState) => storeState);
  const [content, SetContent] = useState({ banner: {} });
  const dispatch = useDispatch();
  const { errorCount, hasError , showAlert, employeeBadRequestCounts} = useSelector((storeState) => storeState.registerationError);
  const { tollNumberFromAuthModule=''} = useSelector((storeState) => storeState.registeration);

 // const errorMax = registerationError.employeeBadRequestCounts >= 2;

  useEffect(() => {
    import(`./Content/${currentLanguage}.json`)
      .then(module => SetContent(module.default))
      .catch(error => console.error("Failed to load content:", error));
  }, [currentLanguage]);

  const { title, subtitle, panelTitle, banner = {}, icon, layout } = content || {};
  // useEffect(() => {
  //   /* useEffect to get all constants through API call */
  //   constantsList.forEach((element) => {
  //     dispatch(callConstants(element));
  //   });
  // }, []);
  const breadcrumbs = [
    { to: '', text: 'Employee' },
    { to: '/searchForAnEmployee', text: 'Search for an Employee' },
  ];

  //  const [content1, setContent] = useState({
  //    title: '',
  //    subtitle: '',
  //    panelTitle: '',
  //    banner: {},
  //    icon: '',
  //    authUrl: '',
  //    redirectUrl: '',
  //    helpLinks: [],
  //    inputPlaceHolder: '',
  //    passwordPlaceHolder: '',
  //    buttonLable: '',
  //    rememberMeLable: '',
  //  });
  const notify = () =>
    toast.error(
      <div>
        You have exceeded the maximum number (3) of attempts. Please contact Mercer Contact Center @
        (xxx) - (xxx) - (xxxx)' for further assistance.'
      </div>
    );
    const filename= {errorFile}
  // "Toll Free Number: 866-751-0257 Hours: 8:00 AM - 5:00 PM Central Time Zone"
  let tollNumber = tollNumberFromAuthModule? tollNumberFromAuthModule.substring(tollNumberFromAuthModule.indexOf(':'), tollNumberFromAuthModule.indexOf('H')): ''
  let tollText = `You have exceeded the maximum number (3) of attempts. Your account will be locked for 15 minutes. Please try again after that time or contact ${tollNumber} if you need further assistance..`

  let generalText = `You have exceeded the maximum number (3) of attempts.`
  

  let imgSrc;
  try {
    imgSrc = iconError;
  } catch (e) {
    imgSrc = '';
  }
  const displayAlert = () => {
    $('#maxWrongTries').show();

    return (
     <div className="col-9 mt-3 mb-0 mx-auto alert alert-danger alert-dismissible fade show" role="alert" id='maxWrongTries'>
    {/* // <div className="col-auto mx-auto alert alert-danger  fade show" role="alert" id='maxWrongTries'> */}


     {/* <Image filename={filename} alt='alt'/> */}
     <img
       src={imgSrc}
       alt='alt'
       className='img-fluid pr-2 ' 
       id="alert-img"
     />
     <span className= "pr-3 ">{tollNumber? tollText : generalText}</span>
     <button   
        className="close mt-1 " 
        onClick={()=>{
          $('#maxWrongTries').hide()
          dispatch(SHOW_ALERT(false))
          dispatch(LOCK_CONTINUE_BUTTON(false))
          dispatch(CLOSE_ERROR({hasError:false}))
          dispatch(CLEAR_EMPLOYEE_VALIDATION_ERROR({hasError: false, clearCount: true, key:  stepForm.currentStep, count: 0 }))
        }}
        style={{color: "#002C77", fontSize: "0.875rem", fontFamily: "NotoSansMedium"}}>CLOSE
     </button>
   </div>
    )
  }
  return (
    <div>
      {/* <SectionHeader title="Add an Employee" breadcrumbs={breadcrumbs} current="Add an Employee" /> */}
      <Suspense fallback={<div>Loading...</div>}>
        <div class="container-fluid">
        {  showAlert && stepForm.currentStep === 'EmployeeValidation' && displayAlert()}

          <div class="row py-3 mt-4">
            {/* {  showAlert && displayAlert()} */}
            {/* <div class="form-row py-3 mt-4"> */}
            <div
              className={`  ${layout && layout.dualColumn ? layout.dualColumn[0] : 'col-md-12'} `}
            >
              {/* // <div className="centered"> */}

              <img
                src={registerImage}
                alt=""
                id="register-img"
                />
            </div>
            <div
              className={`  ${layout && layout.dualColumn ? layout.dualColumn[1] : 'col-md-12'} `}
              id="dualColumn"
            >
              {/* <button onClick={notify}>Make me a toast</button> */}
              <Toaster
                toastOptions={{
                  className: 'toast-message',
                  duration: 3000,

                  style: {
                    border: '1px solid #E6A7A3',
                    padding: '16px',
                    color: '#AB2F26',
                    background: '#FFE8E6',
                  },
                }}
              />

              <div className="formWrapper">
                {/* <div className="form-row py-3 mt-4"> */}
                <FormGenerator content={content} {...props} />
              </div>
            </div>
          </div>
        </div>
      </Suspense>
    </div>
  );
};

export default AddUserRegistration;